<div class="w-screen max-w-2xl font-inter">
  <div class="mb-2 border-b border-gray-200">
    <nav class="-mb-px flex space-x-8" aria-label="Tabs">
      @if ({ tabs: tabs, activeIndex: activeIndex }; as obj) {
        @for (tab of obj.tabs; track tab.label; let index = $index) {
          @if (index === 0 ? !hideFirstTab : true) {
            <button
              type="button"
              class="whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium focus:outline-none"
              [ngClass]="{
                'border-aux-blue-light text-aux-blue-light': index === obj.activeIndex,
                'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                  index !== obj.activeIndex,
              }"
              (click)="onTabChange(index)"
            >
              {{ tab.label }}
            </button>
          }
        }
      }
    </nav>
  </div>
  <div [hidden]="activeIndex !== 0">
    <div class="grid grid-cols-2 gap-5">
      <div class="flex flex-col justify-between">
        <div class="mb-4">
          <div class="mb-2 text-xs">Vendor Contract</div>
          <ng-select
            class="select"
            placeholder="Select"
            id="vendors"
            auxFormError
            [formControl]="selectedVendor"
            [appendTo]="'body'"
            [searchable]="true"
            [clearable]="false"
            (change)="onChangeVendor($event)"
          >
            @for (vendor of organizationQuery.allVendors$ | async; track vendor.id) {
              <ng-option [value]="vendor.id">
                <span [title]="vendor.name">{{ vendor.name }}</span>
              </ng-option>
            }
          </ng-select>
        </div>

        <div>
          <label class="mb-2 block text-xs" for="po_reference">PO #</label>
          <ng-select
            class="tabular-nums"
            id="po_reference"
            [appendTo]="'body'"
            [searchable]="true"
            [multiple]="false"
            [formControl]="selectedPOReference"
            [clearable]="true"
          >
            @for (po of filteredPONumbers$ | async; track po.id) {
              <ng-option [value]="po.id">
                {{ po.po_number }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="mb-2 text-xs">Upload invoice and supporting docs</div>
        <aux-file-manager #singleFileManager class="h-24" [eager]="false" [path]="path" />
      </div>
    </div>

    @if (files$ | async; as files) {
      @if (files?.length) {
        <div class="mt-4 grid max-h-[300px] grid-cols-12 overflow-y-scroll">
          <div class="col-span-7 border-b-2 pb-2 text-xs">Uploaded Files</div>
          <div class="col-span-5 border-b-2 pb-2 text-xs">Designation</div>
          @for (file of files; track file.id) {
            <div class="col-span-7 flex items-center break-all border-b p-2">
              {{ file.fileName }}
            </div>

            <div class="col-span-4 flex items-center border-b py-2">
              <div
                class="flex flex-1 items-center"
                [auxTooltip]="file.type !== pdf ? 'Invoice file type must be PDF' : ''"
              >
                <input
                  type="radio"
                  value="invoice"
                  class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  [id]="file.id + 'inc'"
                  [name]="file.id"
                  [disabled]="file.type !== pdf || oneInvoiceSelected"
                  [(ngModel)]="obj[file.id]"
                  (ngModelChange)="updateValidation.next(null)"
                />
                <label class="ml-3" [for]="file.id + 'inc'">
                  <span class="block text-sm font-medium text-gray-700">Invoice</span>
                </label>
              </div>

              <div class="flex flex-1 items-center">
                <input
                  type="radio"
                  value="supporting"
                  class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  [id]="file.id + 'sup'"
                  [name]="file.id"
                  [(ngModel)]="obj[file.id]"
                  (ngModelChange)="updateValidation.next(null)"
                />
                <label class="ml-3" [for]="file.id + 'sup'">
                  <span class="block text-sm font-medium text-gray-700">Supporting Document</span>
                </label>
              </div>
            </div>

            <div class="flex justify-end border-b">
              <button class="p-2" type="button" (click)="removeFile(file)">
                <aux-icon name="Trash" class="text-aux-error" />
              </button>
            </div>
          }
        </div>
      }
    }
  </div>

  <div [hidden]="activeIndex !== 1">
    <div class="mb-2 grid grid-cols-1 gap-5">
      <div class="flex flex-col">
        <aux-download-template-button
          label="Download Bulk Invoice Template"
          class="mb-4"
          [templateType]="invoiceTemplateType"
        />

        <div class="mb-2 text-xs">Upload Bulk Invoice Template</div>
        <aux-file-manager
          #bulkFileManager
          class="h-24"
          [fetchFilesOnInit]="false"
          [path]="path"
          [eager]="false"
          [showSuccessOnUpload]="true"
        />
      </div>
    </div>

    @if (bulkFiles$ | async; as bulkFiles) {
      @if (bulkFiles?.length) {
        <div class="mt-4 grid max-h-[300px] grid-cols-12 overflow-y-auto">
          <div class="col-span-12 pb-2 text-xs">Uploaded Files</div>

          @for (bulkFile of bulkFiles; track bulkFile.id) {
            <div class="col-span-11 flex items-center break-all border-b p-2">
              {{ bulkFile.fileName }}
            </div>

            <div class="flex justify-end border-b">
              <button class="p-2" (click)="removeBulkFile(bulkFile)">
                <aux-icon name="Trash" class="text-aux-error" />
              </button>
            </div>
          }
        </div>
      }
    }

    @if (errorMessage()) {
      <div class="mt-4 rounded-md bg-aux-error p-5 font-medium text-white">
        {{ errorMessage() }}
      </div>
    }
  </div>

  <div [hidden]="activeIndex !== 2">
    <div class="mb-2 grid grid-cols-1 gap-5">
      <div class="flex flex-col">
        <aux-download-template-button
          label="Download Bulk Invoice Update Template"
          class="mb-4"
          [templateType]="invoiceBulkUpdateTemplateType"
        />

        <div class="mb-2 text-xs">Upload Bulk Invoice Update Template</div>
        <aux-file-manager
          #bulkUpdateFileManager
          class="h-24"
          [fetchFilesOnInit]="false"
          [path]="path"
          [eager]="false"
          [showSuccessOnUpload]="true"
        />
      </div>
    </div>

    @if (bulkUpdateFiles$ | async; as bulkUpdateFiles) {
      @if (bulkUpdateFiles?.length) {
        <div class="mt-4 grid max-h-[300px] grid-cols-12 overflow-y-auto">
          <div class="col-span-12 pb-2 text-xs">Uploaded Files</div>

          @for (bulkUpdateFile of bulkUpdateFiles; track bulkUpdateFile.id) {
            <div class="col-span-11 flex items-center break-all border-b p-2">
              {{ bulkUpdateFile.fileName }}
            </div>

            <div class="flex justify-end border-b">
              <button class="p-2" (click)="removeBulkUpdateFile(bulkUpdateFile)">
                <aux-icon name="Trash" class="text-aux-error" />
              </button>
            </div>
          }
        </div>
      }
    }

    @if (errorMessage()) {
      <div class="mt-4 rounded-md bg-aux-error p-5 font-medium text-white">
        {{ errorMessage() }}
      </div>
    }
  </div>
</div>
